import UserPhoto from '../../shared/UserPhoto'
import FormUtils from '../../../form-utils'
import AvatarSelect from './avatarSelect/AvatarSelect.vue'
import Utils from '../../../utils'
import config from '../../../config'
import UserInterests from './userInterests/UserInterests.vue'
import UserLanguages from './userLanguages/UserLanguages.vue'
import UserSkills from './userSkills/UserSkills.vue'
import axios from 'axios'

export default {
  name: 'UserIdentity',
  components: { UserPhoto, AvatarSelect, UserInterests, UserLanguages, UserSkills },
  data() {
    return {
      editing: false,
      image: '',
      editUserData: {},
      showMenu: false,
      editedInterests: [],
      editedLanguages: []
    }
  },
  props: {
    editable: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    interests: {
      type: Array,
      default: () => []
    },
    languages: {
      type: Array,
      default: () => []
    },
    skills: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    'user'() {
      // watch so data updates when changing user from search
      this.editing = false
      this.editUserData = this.buildEditUserData()
    }
  },
  computed: {
    mailLink() {
      return 'mailto:' + this.user.email
    },
    languageList() {
      return this.$i18n.availableLocales.filter(l => this.$i18n.locale !== l)
    },
    avatarData() {
      const image = this.$store.getters.image(this.user.idImage)
      return Utils.validBase64SrcString(image)
    }
  },
  methods: {
    exportPersonalData() {
      window.open(`${config.getRootApi()}/me/exportPersonalData`, '_blank')
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    hideMenu() {
      this.showMenu = false
    },
    changeLanguage(val) {
      this.$i18n.locale = val
      this.$store.dispatch('changeLocale', val)
    },
    toggleEdit() {
      this.editing = !this.editing
      this.editUserData = this.buildEditUserData()
      this.editedInterests = this.interests.slice()
      this.editedLanguages = this.languages.slice()
    },
    async logout() {
      const store = this.$store
      await axios.post(`${config.getRootApi()}/auth/logout`, { withCredentials: true })
        .then(function(response) {
          if (response.status === 200) {
            store.dispatch('redirectToAuthWorkflow')
          }
        }).catch(function(err) {
          console.log(err)
        })
    },
    saveUserProfile() {
      let formData = new FormData()
      if (this.image) {
        FormUtils.append(formData, 'avatar', this.image.data)
        FormUtils.append(formData, 'avatarName', this.image.filename)
      }
      FormUtils.append(formData, 'id', this.user.id)
      FormUtils.appendObject(formData, this.editUserData, true)
      this.$store.dispatch('updateMyProfile', formData).then(() => {
        this.$store.dispatch('updateInterests', { interests: this.editedInterests }).then(() => {
          this.$store.dispatch('updateLanguages', { languages: this.editedLanguages }).then(() => {
            this.editing = false
          })
        })
      })
    },
    onChangeImage(image) {
      this.image = image
    },
    onRemoveImage() {
      this.image = null
    },
    buildEditUserData() {
      return {
        jobTitle: this.user.jobTitle,
        businessLine: this.user.businessLine,
        country: this.user.country
      }
    }
  }
}
